import { Selector } from '@ngxs/store';
import { AuthState, AuthStateModel } from '../states/auth.state';
import { LoginApiResponse } from '@shared/interfaces/user'; // Import your AuthState and AuthStateModel

export class AuthSelectors {
  @Selector([AuthState])
  static isAuthenticated(state: AuthStateModel | undefined): boolean {
    return state?.isAuthenticated ?? false;
  }

  @Selector([AuthState])
  static currentUser(state: AuthStateModel | undefined): LoginApiResponse | null {
    return state?.login ?? null;
  }

  @Selector([AuthState])
  static error(state: AuthStateModel | undefined): Record<string, string[] | string> {
    return state?.error ?? {};
  }
  @Selector([AuthState])
  static forgotPasswordMessage(state: AuthStateModel | undefined): {
    message: string;
    isSuccess: boolean;
  } {
    return state?.forgotPassword ?? { message: null, isSuccess: false };
  }
  @Selector([AuthState])
  static changePasswordMessage(state: AuthStateModel | undefined): {
    message: string;
    isSuccess: boolean;
  } {
    return state?.changePassword ?? { message: null, isSuccess: false };
  }
  @Selector([AuthState])
  static resetPasswordMessage(state: AuthStateModel | undefined): {
    message: string;
    isSuccess: boolean;
  } {
    return state?.resetPassword ?? { message: null, isSuccess: false };
  }
}
